var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBritain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 17.9997V0H0V17.9997H27Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 17.9997V0H0V17.9997H27Z",
    fill: "#33348E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6297 17.9997V11.7196H27V6.28004H16.6297V0H10.2246V6.28004H0V11.7196H10.2246V17.9997H16.6297Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28812 0L27 15.8084V18H23.7704L0 2.15251V0H3.28812Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.712 0L0 15.8084V18H3.22974L27 2.15251V0H23.712Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 7.26366H15.4529V0H11.5581V7.26366H0V10.736H11.5581V17.9997H15.4529V10.736H27V7.26366Z",
    fill: "#CC2229"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0122903 0L9.39211 6.28004H7.28693L0 1.40114V0H0.0122903ZM0 17.9684V18H2.05771L10.2246 12.532V11.7196H9.33281L0 17.9684ZM27 18V16.6879L19.5793 11.7196H17.4741L26.8545 18H27ZM24.7742 0L16.6297 5.45311V6.28004H17.4996L26.8794 0H24.7742Z",
    fill: "#CC2229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritain);
export default __webpack_public_path__ + "static/media/Britain.e90aa0808fcb6b70d030617193f0dfb9.svg";
export { ForwardRef as ReactComponent };